import { ArrowUpRight } from "lucide-react";
import { KineticLines, Reveal } from "@/components/Reveal";
import { IMG, SOCIALS } from "@/lib/images";
import { track } from "@/lib/track";

const GALLERY = [
  IMG.heroMaster,
  IMG.ripe.strawberry,
  IMG.storefront,
  IMG.ripe.sitaphal,
  IMG.storefrontPortrait,
  IMG.ripe.coconut,
];

export default function SocialSection() {
  return (
    <section className="bg-cream py-16 md:py-24" data-testid="social-section">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        <div className="text-center">
          <Reveal>
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-orange-rific md:text-xs">Social</p>
          </Reveal>
          <KineticLines
            lines={["SCOOP. SHARE.", "REPEAT."]}
            className="mt-3 block"
            lineClassName="font-display text-[clamp(2rem,4.2vw,3.25rem)] font-extrabold leading-[1.05] tracking-[-0.01em] text-deep"
          />
          <Reveal delay={0.2}>
            <p className="mx-auto mt-5 max-w-md text-base leading-relaxed text-deep/75 md:text-lg">
              Follow along for seasonal drops, store stories and very good ice cream.
            </p>
            <a
              href={SOCIALS[0].url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="social-instagram-cta"
              onClick={() => track("instagram_click", { placement: "social_section" })}
              className="mt-7 inline-flex items-center gap-2 rounded-full bg-orange-rific px-8 py-4 text-sm font-bold uppercase tracking-[0.16em] text-white transition-colors duration-300 hover:bg-deep"
            >
              Follow @rific.in
              <ArrowUpRight className="h-4 w-4" />
            </a>
          </Reveal>
        </div>

        <div className="mt-12 grid grid-cols-2 gap-4 md:mt-16 md:grid-cols-3 md:gap-6" data-testid="social-gallery">
          {GALLERY.map((src, i) => (
            <Reveal key={i} delay={i * 0.05}>
              <div className="overflow-hidden rounded-2xl bg-cream">
                <img
                  src={src}
                  alt="RIFIC on Instagram"
                  loading="lazy"
                  className="h-auto w-full object-contain"
                />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
